import { render, staticRenderFns } from "./FloorMap.vue?vue&type=template&id=213c6234&"
import script from "./FloorMap.vue?vue&type=script&lang=js&"
export * from "./FloorMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports